import React from 'react';

const FAQ = () => {
  const faqs = [
    {
      question: 'Are the courses available online?',
      answer: 'Yes, selected courses are offered online with live sessions and recorded materials.',
    },
    {
      question: 'Do you provide certifications?',
      answer: 'Yes, trainees receive an industry-recognized certificate upon course completion.',
    },
    {
      question: 'What is the eligibility for enrollment?',
      answer: 'Open to students and professionals with a basic understanding of civil engineering.',
    },
    {
      question: 'What is the fee structure?',
      answer: 'The fee depends on the course. Detailed information is available on the Training page.',
    },
    {
      question: 'What is the placement support provided?',
      answer: 'Placement assistance includes resume building, mock interviews, and connecting with industry partners.',
    },
  ];

  return (
    <div className="container py-5" style={{margin:"auto"}}>
      <center>
        <img
          src="/images/logo/FAQs.gif"
          alt="FAQ"
          className="img-fluid mt-4"
          style={{ maxHeight: '300px', height: 'auto' }}
        />
      </center>
      <div className="mt-4">
        {faqs.map((faq, index) => (
          <div className="faq-item mb-4" key={index}>
            <h5 className="fw-bold">{faq.question}</h5>
            <p>{faq.answer}</p>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FAQ;
